import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeEDI315ListItem extends SearchModelBase {
    id: number = 0;
    description: string = '';
    status: string = '';
    equipment: string = '';
    check: boolean = false;
    ediOrder: number|null = 0;
    toEdiOrder: number|null = null;
    fromEdiOrder: number|null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Event Description', width: 300, dataIndex: 'description'}),
        XCol.Create({ col: 1, text: 'Status', width: 60, dataIndex: 'status'}),
        XCol.Create({ col: 2, text: 'Equipment', width: 70, dataIndex: 'equipment'}),
        XCol.Create({ col: 3, text: 'Order', width: 100, dataIndex: 'ediOrder', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeEDI315ListItem.prototype.ediOrder, orderByAscending: false };

    public static formatData(data: CodeEDI315ListItem[]) {
        return data.map((d: CodeEDI315ListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        ediOrder: {from: 'fromEdiOrder', to: 'toEdiOrder'},
    }
}
